import * as React from 'react';

import { ACTIVE, DISABLED, INDETERMINATE } from '../../utils/constants';

const indeterminateBlackSrc = 'https://assets.quill.org/images/icons/xs/dash-black.svg'
const indeterminateWhiteSrc = 'https://assets.quill.org/images/icons/xs/dash-white.svg'
const smallBlackCheckSrc = 'https://assets.quill.org/images/icons/xs/check-small.svg'
const smallWhiteCheckSrc = 'https://assets.quill.org/images/icons/xs/check-small-white.svg'

const DARK = 'dark'
const LIGHT = 'light'

interface checkboxProps {
  label?: string;
  mode?: string;
  onClick?: (e) => void;
  state?: string;
  selected: boolean;
  id?: string;
  ariaLabel?: string;
}

export const Checkbox = ({ label, mode=LIGHT, onClick, state, selected, id, ariaLabel, }: checkboxProps) => {
  const checkboxId = id || label
  const labelId = React.useId()
  const labelClass = `${state === DISABLED ? DISABLED : ''} ${mode}`
  const modeClass = mode === LIGHT ? `${mode} focus-on-light` : `${mode} focus-on-dark`

  function renderCheck() {
    if (state === INDETERMINATE) { return <img alt="dash" src={mode === DARK ? indeterminateBlackSrc : indeterminateWhiteSrc} /> }
    if(!selected) { return }
    return mode === DARK ? <img alt="check" src={smallBlackCheckSrc} /> : <img alt="check" src={smallWhiteCheckSrc} />
  }

  function renderCheckbox() {
    const Element = onClick ? 'button' : 'div'
    const name = label && !ariaLabel ? { 'aria-labelledby': labelId, } : { 'aria-label': ariaLabel || 'Toggle selection', }
    const sharedProps = {
      'aria-checked': onClick ? !!selected : null,
      id: checkboxId,
      onClick,
      role: onClick ? 'checkbox' : null,
      ...(onClick && { type: 'button' as const, ...name, }),
    }

    let className = `quill-checkbox unselected ${modeClass}`

    if (state === INDETERMINATE) {
      className = `quill-checkbox indeterminate ${modeClass}`
    } else if (state === DISABLED) {
      className = `quill-checkbox ${selected ? 'selected' : 'unselected'} ${modeClass} disabled`
    } else if (selected) {
      className = `quill-checkbox selected ${modeClass}`
    }

    return (
      <Element {...sharedProps} className={className} disabled={state === DISABLED || undefined}>
        {renderCheck()}
      </Element>
    )
  }

  return (
    <div className="checkbox-container">
      {renderCheckbox()}
      {label && <label className={labelClass} htmlFor={checkboxId} id={labelId}>{label}</label>}
    </div>
  );
};

export default Checkbox
